import React from 'react';
import { MonoLabel } from '../../Editorial';
import { Rows, hasRows } from '../StatRows';

/* "Crime" accordion — Clery Act on-campus figures. This data has always been
   in the match-detail payload; web simply never rendered it.
   Mirrors `crimeBody` in MatchDetailSheet.swift. */

const GROUPS = [
  { title: 'Interpersonal', measures: [
    ['Stalking', 'stalking'],
    ['Dating violence', 'dating_viol'],
    ['Domestic violence', 'domestic_viol'],
  ] },
  { title: 'Sexual', measures: [
    ['Rape', 'rape'],
    ['Fondling', 'fondling'],
  ] },
  { title: 'Violent', measures: [
    ['Murder', 'murder'],
    ['Aggravated assault', 'agg_assault'],
  ] },
  { title: 'Property', measures: [
    ['Burglary', 'burglary'],
    ['Motor vehicle theft', 'mv_theft'],
  ] },
  { title: 'Substance', measures: [
    ['Drug arrests', 'drug_arrests'],
    ['Liquor arrests', 'liquor_arrests'],
  ] },
];

/** A null count hides the row; a rate renders alongside as "7  (0.6/1k)". */
function crimeValue(stat) {
  if (!stat || stat.count == null) return null;
  if (stat.rate != null) return `${stat.count}  (${Number(stat.rate).toFixed(1)}/1k)`;
  return String(stat.count);
}

function crimeContext(c) {
  if (c.data_year == null) return null;
  if (c.enrollment != null) {
    return `On-campus · ${c.data_year} · ${Number(c.enrollment).toLocaleString()} students`;
  }
  return `On-campus · ${c.data_year}`;
}

function build(detail) {
  const c = detail.crime;
  if (!c) return null;
  return {
    c,
    groups: GROUPS
      .map((g) => ({
        title: g.title,
        rows: g.measures.map(([label, key]) => ({ label, value: crimeValue(c[key]) })),
      }))
      .filter((g) => hasRows(g.rows)),
  };
}

export function hasContent(detail) {
  const b = build(detail);
  return Boolean(b) && b.groups.length > 0;
}

export default function CrimeSection({ detail }) {
  const b = build(detail);
  if (!b || b.groups.length === 0) return null;
  const context = crimeContext(b.c);

  return (
    <div data-testid="match_detail_crime_section">
      {context && <p className="sd-note">{context}</p>}
      {b.groups.map((g) => (
        <div className="sd-crime__group" key={g.title}>
          <div className="sd-crime__grouptitle"><MonoLabel>{g.title}</MonoLabel></div>
          <Rows rows={g.rows} />
        </div>
      ))}
      <p className="sd-source">Source: U.S. Dept. of Education (Clery Act)</p>
    </div>
  );
}
